/**
 * Amazon Bidder
 * Handles header bidding with Amazon
 * version 2.2.2
 * 
 * Using Semantic Versioning, please update accordingly to keep files in sync across code bases
 * 
 * Given a version number MAJOR.MINOR.PATCH, increment the:
 *  1. MAJOR version when you implement a full re-build of the architecture,
 *  2. MINOR version when you add functionality, and
 *  3. PATCH version when you implement bug fixes or make small  tweaks to current functionality.
 */
define('AdBidders/amazon',[
    "jquery",
    "logging",
    "utilities",
    "AdPlatforms/dfp"
], function ($, logging, utilities, dfp) {
    "use strict";

    var _ModuleName = "Amazon Header Bidding";

    var _config = {}
    var _data = {
        slots: [],
        monitorName: '',
        dfpMonitorSubscriptionName: 'amazon'
    }

    var _initialized = false;
    var init = function (config, monitorName) {
        $.extend(_config, config.bidders.amazon);
        
        // store monitor name
        _data.monitorName = monitorName;

        if (!_config.enabled) return;
        ;

        // Subscribe to Ready Monitor
        utilities.subscribeToReadyMonitor(_data.monitorName, _data.dfpMonitorSubscriptionName);

        ;
        window.apstag = window.apstag || {
            init: function () { _queue("i", arguments) },
            fetchBids: function () { _queue("f", arguments) },
            setDisplayBids: function () { },
            _Q: []
        };

        ;
        _loadAmazonJs(function () {
            _initialized = true;
            if (_initialized && _data.slots.length > 0) run();
        });

        ;
    }

    var _queue = function (c, r) {
        window.apstag._Q.push([c, r]);
    }

    var _loadAmazonJs = function (success) {
        if ($('script[src="' + _config.scriptUrl + '"]').length == 0) {
            $.ajax({
                url: _config.scriptUrl,
                dataType: "script",
                cache: true,
                success: function () {
                    ;

                    if (typeof success == 'function') {
                        ;
                        success();
                    }
                }
            }).fail(function () {
                logging.error("Something went wrong loading Amazon JS", _ModuleName);
            });
        } else {
            ;

            if (typeof success == 'function') {
                ;
                success();
            }
        }
    }

    var start = function () {
        if (_initialized && _data.slots.length > 0) run();
    }

    var setNetworkId = function (id) {
        _config.networkId = id;
    }

    var _running = false;
    var run = function () {
        if (_running) return;
        _running = true;

        ;
        window.apstag.init({
            pubID: _config.pubId,
            adServer: 'googletag',
            bidTimeout: _config.timeout
        });

        refreshAdSlots(_data.slots, _data.monitorName);
    }

    var registerAdSlots = function (slots) {
        if (!_config.enabled) return;

        // filter the slots to remove any excluded slots
        if (Array.isArray(_config.exclusions) && _config.exclusions.length > 0) {
            slots = slots.filter(function (slot) {
                return typeof _config.exclusions.find(function (exclusion) { return exclusion == slot.position; }) == 'undefined';
            });
        }

        if (slots) {
            ;
            _data.slots = slots;
        } else {
            logging.warn("There was a problem registering ad slots. None were defined", _ModuleName);
        }
    }

    var refreshAdSlots = function (slots, monitor) {
        // Subscribe to Ready Monitor if we're not already subscribed
        if (!utilities.isSubscribedToReadyMonitor(monitor, _data.dfpMonitorSubscriptionName)) {
            utilities.subscribeToReadyMonitor(monitor, _data.dfpMonitorSubscriptionName);
        }

        // Generate Slot Defs
        var aznSlots = [];
        for (var i = 0; i < slots.length; i++) {
            var slot = slots[i];
            aznSlots.push({
                slotID: slot.id,
                slotName: _config.networkId + '/' + slot.position,
                sizes: slot.sizes
            });
        }

        // Initiate Bidding
        ;
        var start = new Date();
        window.apstag.fetchBids({
            slots: aznSlots
        }, function (bids) {
            var now = new Date();
            var elapsed = now.getTime() - start.getTime();
            logging.log("Amazon bidding completed in " + elapsed + "ms", _ModuleName);
            // trigger the request to DFP
            dfp.enqueue(function () {
                ;
                window.apstag.setDisplayBids();

                // Confirm Ready with Ready Monitor
                ;
                utilities.confirmReady(monitor, _data.dfpMonitorSubscriptionName);
            });
        });
    }

    /**
     * Removes slot from being tracked
     */
    var removeSlot = function (slot) {
        try {
            var index = _data.slots.findIndex(function (s) { return s.id == slot.id; });
            if (index >= 0) {
                ;
                _data.slots.splice(index, 1);
                ;
            }
        } catch (error) {
            logging.error("Failed to remove slot", _ModuleName);
            logging.error(error, _ModuleName);
        }
    }

    return {
        enabled: (function () { return _config.enabled; }),
        init: init,
        start: start,
        registerAdSlots: registerAdSlots,
        refreshAdSlots: refreshAdSlots,
        setNetworkId: setNetworkId,
        removeSlot: removeSlot
    }
});
